import { Format1, Format2, Format3, Format4 } from "./utilities";
/**
 * Returns correct date formatter based on passed date format.
 * @param {String} dateFormat
 */

export function getDateFormat(dateFormat) {
  let matchingDateFormatter;

  switch (dateFormat) {
    case "mm/dd/yyyy":
      matchingDateFormatter = Format1;
      break;

    case "dd/mm/yyyy":
      matchingDateFormatter = Format2;
      break;

    case "mmm-dd-yyyy":
      matchingDateFormatter = Format3;
      break;

    case "dd-mmm-yyyy":
      matchingDateFormatter = Format4;
      break;

    default:
      matchingDateFormatter = dateFormat;
      break;
  }

  return matchingDateFormatter;
}
/**
 * Returns valid date based on passed date and dateFormatter.
 * This is needed because new Date(date) in Firefox gives negative year
 * for date format "dd-mmm-yyyy" and `invalid date` for date format "mmm-dd-yyyy".
 * @param {String} date
 * @param {Object} dateFormatter
 */

export function getValidConvertedDate(date, dateFormatter) {
  const validConvertedDate = dateFormatter.convertToDate(date);
  return validConvertedDate;
}
/**
 * @description A utility function that converts a date object with time to date only.
 *              Setting hours as 0 to ignore the time and consider only date.
 * @param {Date} dateObj The Date object to convert.
 * @returns {Date} Returns date only by remove time.
 */

export function removeTime(dateObj) {
  return dateObj.setHours(0, 0, 0, 0);
}